import { atom, type PrimitiveAtom } from 'jotai';
import Cookies from 'js-cookie';
import type { SetStateAction } from 'react';
import { PERSISTED_CACHE_KEY } from '~/constants/storage';

type AsJson<T> = T extends string | number | boolean | null ? T : T extends (...args: never[]) => unknown ? never : T extends Record<string, unknown> ? { [K in keyof T]: AsJson<T[K]> } : never;

export function atomWithCookieStorage<Value>(key: string, initialValue: AsJson<Value>): PrimitiveAtom<Value> {
    const getInitialValue = () => {
        const state = Cookies.get(PERSISTED_CACHE_KEY);
        if (state !== null && state !== undefined) {
            try {
                const raw = JSON.parse(state) || {};
                return raw[key] || null;
            } catch {
                // Cookie corrompu : on retombe sur la valeur initiale
            }
        }
        return initialValue;
    };

    const baseAtom = atom(getInitialValue());
    return atom(
        (get) => get(baseAtom),
        (get, set, update: SetStateAction<Value>) => {
            const newValue = typeof update === 'function' ? (update as (prev: Value) => Value)(get(baseAtom)) : update;
            set(baseAtom, newValue);

            const state = Cookies.get(PERSISTED_CACHE_KEY) || '';
            try {
                const raw = JSON.parse(state) || {};
                raw[key] = newValue;
                Cookies.set(PERSISTED_CACHE_KEY, JSON.stringify(raw));
            } catch {
                Cookies.set(PERSISTED_CACHE_KEY, JSON.stringify({ [key]: newValue }));
            }
        },
    );
}
